import { useToast } from '@/hooks/use-toast'
import { 
  CheckCircle2, 
  XCircle, 
  AlertCircle, 
  X,
  Info
} from 'lucide-react'
import { cn } from '@/lib/utils'
import { AnimatePresence, motion } from 'framer-motion'

export function Toaster() {
  const { toasts, dismiss } = useToast()

  return (
    <div className="fixed bottom-0 right-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]">
      <AnimatePresence mode="sync">
        {toasts.map((toast) => {
          const Icon = toast.variant === 'destructive' 
            ? XCircle 
            : toast.variant === 'success' 
            ? CheckCircle2
            : toast.variant === 'default'
            ? Info
            : AlertCircle

          return (
            <motion.div
              key={toast.id}
              initial={{ opacity: 0, y: 50, scale: 0.3 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ 
                opacity: 0, 
                scale: 0.5, 
                transition: { duration: 0.2 }
              }}
              className={cn(
                "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-lg border p-4 pr-6 shadow-lg transition-all mb-2",
                toast.variant === 'destructive' && "bg-red-950 border-red-900 text-red-100",
                toast.variant === 'success' && "bg-green-950 border-green-900 text-green-100",
                !toast.variant && "bg-dark-900 border-dark-700 text-white",
                toast.className
              )}
            >
              <div className="flex items-start gap-3">
                <Icon className={cn(
                  "h-5 w-5 flex-shrink-0 mt-0.5",
                  toast.variant === 'destructive' && "text-red-400",
                  toast.variant === 'success' && "text-green-400",
                  !toast.variant && "text-kinky-500"
                )} />
                <div className="grid gap-1">
                  {toast.title && (
                    <div className="text-sm font-semibold">
                      {toast.title}
                    </div>
                  )}
                  {toast.description && (
                    <div className="text-sm opacity-90">
                      {toast.description}
                    </div>
                  )}
                  {toast.action}
                </div>
              </div>
              <button
                onClick={() => dismiss(toast.id)}
                className={cn(
                  "absolute right-2 top-2 rounded-md p-1 opacity-0 transition-opacity hover:opacity-100 focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100",
                  toast.variant === 'destructive' && "hover:bg-red-900 focus:ring-red-400",
                  toast.variant === 'success' && "hover:bg-green-900 focus:ring-green-400",
                  !toast.variant && "hover:bg-dark-700 focus:ring-kinky-500"
                )}
              >
                <X className="h-4 w-4" />
              </button>
            </motion.div>
          )
        })}
      </AnimatePresence>
    </div>
  )
}